import { Component, OnInit, Input, Output, EventEmitter, AfterViewChecked } from '@angular/core';
import { Attending } from '../../model/attending';
import { AutoEletric } from '../../../shared/model/auto-eletric';
import { AutoEletricService } from '../../../shared/service/auto-eletric.service';
import { Technician } from '../../../shared/model/technician';
import { TechnicianService } from '../../../shared/service/technician.service';
import { Scheduling } from '../../model/scheduling';
import { BestAutoEletric } from '../../model/best-auto-eletric';
import { MaterializeAction } from 'angular2-materialize';
import * as moment from 'moment';
import * as datePickerOptions from '../../../core/date-picker-options';
import { AuthenticationService } from '../../../shared/service/authentication.service';
import { ToastService } from '../../../shared/service/toast.service';

declare var Materialize: any;

@Component({
  selector: 'tx-scheduling',
  templateUrl: './scheduling.component.html',
  styleUrls: ['./scheduling.component.css']
})
export class SchedulingComponent implements OnInit, AfterViewChecked {
  private _attending: Attending = new Attending();
  @Input() editable: boolean;
  @Output() txOnSave: EventEmitter<Attending> = new EventEmitter();
  @Output() txOnCancel: EventEmitter<any> = new EventEmitter();

  autoEletricAttributesTree = ['name'];
  argosAutoEletrics: Array<BestAutoEletric>;
  userAutoEletrics: Array<AutoEletric>;
  technicians: Array<Technician>;
  autoEletricsResultLimit = 3;
  datePickerFormat = datePickerOptions.minDatePicker;
  timePickerFormat = datePickerOptions.timePicker;

  schedulingDateActions = new EventEmitter<string|MaterializeAction>();
  schedulingTimeActions = new EventEmitter<string|MaterializeAction>();
  time: string;
  date: string;
  private datePickerIsOpen = false;
  private timePickerIsOpen = false;
  authenticatedUser: any;
  SCHEDULING = 'SCHEDULING';
  autoEletricId: any;
  autoEletricChoosedOnScheduling: Boolean = false;
  suggestedByArgos: Boolean = null;

  constructor(private _autoEletricService: AutoEletricService,
              private _technicianService: TechnicianService,
              private _authService: AuthenticationService,
              private _toastService: ToastService) {
  }

  ngOnInit() {
    this.setEmptyEntities();
    this.setUpObservers();
  }

  ngAfterViewChecked() {
    try {
      Materialize.updateTextFields();
    } catch (e) { }
  }

  get attending() {
    return this._attending;
  }

  @Input()
  set attending(attending) {

    this._attending = attending;

    this.setEmptyEntities();
    this.findArgosAutoEletrics();

    if (this._attending.attendingInfo.autoEletric) {
      this.findTechnicians(this._attending.attendingInfo.autoEletric);
    }

    this.showStep();
  }

  save() {
    if (this.validateScheduleDate()) {
      if (this.autoEletricId != null && this.autoEletricChoosedOnScheduling) {
        if (this.suggestedByArgos == null) {
          this.suggestedByArgos = true;
        }

        let associateAutoEletric = {'attendingInfoId': this.attending.attendingInfo.id, 'autoEletricId': this.autoEletricId,
          'autoEletricStep': 'SCHEDULING', 'suggestedByArgos': this.suggestedByArgos};
        this.attending.scheduling.associateAutoeletric = associateAutoEletric;
      }

      this.attending.scheduling.scheduleDate = moment(`${this.date} ${this.time}`, 'DD/MM/YYYY HH:mm');
      this.txOnSave.emit(this.attending);
    } else {
      this.showMessage('Informe a data e a hora do atendimento!');
    }
  }

  cancel() {
    this.txOnCancel.emit();
  }

  findAutoEletric(name) {
    if (this.canEdit()) {
      this._autoEletricService.findByName(name);
    }
  }

  findArgosAutoEletrics() {
    if (this.attending.screening.providedServices.length > 0 && this.canEdit()) {
      this._autoEletricService
        .findBests(this.getSearchParams())
        .subscribe(
          autoEletrics => this.argosAutoEletrics = autoEletrics,
          error => this.showMessage(error.text)
        );
    }
  }

  selectAutoEletric(autoEletric) {
    if (this.autoEletricId === autoEletric.id) {
      this.attending.attendingInfo.autoEletric = null;
      this.autoEletricId = null;
      this.suggestedByArgos = null;
    } else {
      this.attending.attendingInfo.autoEletric = autoEletric;
      this.autoEletricId = autoEletric.id;
      this.suggestedByArgos = false;
      this.autoEletricChoosedOnScheduling = true;
      this.findTechnicians(autoEletric);
    }
  }

  selectAutoEletricSuggestedByArgos(autoEletric) {
    if (this.autoEletricId === autoEletric.id) {
      this.attending.attendingInfo.autoEletric = null;
      this.autoEletricId = null;
      this.suggestedByArgos = null;
    } else {
      this.attending.attendingInfo.autoEletric = autoEletric;
      this.autoEletricId = autoEletric.id;
      this.suggestedByArgos = true;
      this.autoEletricChoosedOnScheduling = true;
      this.findTechnicians(autoEletric);
    }
  }

  setTechnician(technician) {
    this.attending.scheduling.technician = technician;
    this.attending.scheduling.technicianContact = this.attending.scheduling.technician.phone;
  }

  toggleDatePicker() {
    this.schedulingDateActions.emit({action: 'pickadate', params: ['open']});
  }

  toggleTimePicker() {
    this.schedulingTimeActions.emit({action: 'pickatime', params: ['show']});
  }

  getFormatedDate() {
    if (this.attending.scheduling.scheduleDate) {
      const scheduleDate = new Date(this.attending.scheduling.scheduleDate);
      return moment(scheduleDate).format('DD/MM/YYYY HH:mm');
    }
  }

  canEdit() {
    return (this.attending.scheduling.canEdit || this.attending.scheduling.canEdit === undefined) && this.editable;
  }

  canView() {
    return this.attending.scheduling.canView && !this.canEdit();
  }

  canViewComponent(types: Array<string>) {

    return types.includes(this.attending.type);
  }

  private getSearchParams() {
    return {
      providedServices: this.attending.screening.providedServices,
      branchId: this.attending.branch ? this.attending.branch.id : null,
      equipmentModelId: this.attending.screening.equipmentModel ? this.attending.screening.equipmentModel.id : null,
      resultLimit: this.autoEletricsResultLimit,
      accessoryMovementLogs: this.attending.accessoryMovementLogs
    };
  }

  private validateScheduleDate() {
    return this.date && this.time;
  }

  private showStep() {
    if (this.attending.orderedSteps && this.attending.currentStep === this.SCHEDULING) {
      this.setIsVisible();
      this.setIsEditable();
    }
  }

  private setIsVisible() {
    if (this.attending.orderedSteps.includes(this.SCHEDULING)
        && this.authenticatedUser.stepViews.find(view => view.stepViewType === this.SCHEDULING)) {
      this.attending.scheduling.canView = true;
    } else {
      this.attending.dispatch.canView = false;
    }
  }

  private setIsEditable() {
    if (this.authenticatedUser.stepKeys.find(view => view.stepType === this.SCHEDULING)) {
      this.attending.scheduling.canEdit = true;
    } else {
      this.attending.scheduling.canEdit = false;
    }
  }

  private findTechnicians(autoEletric) {
    if (this.canEdit()) {
      this._technicianService
        .findByProvidedServicesAndAutoEletricId(this.attending.screening.providedServices, autoEletric.id)
        .subscribe(
          technicians => this.technicians = technicians,
          error => this.showMessage(error.text)
        );
    }
  }

  private showMessage(message) {
    this._toastService.showMessage(message, 4000);
  }

  private setEmptyEntities() {
    this.authenticatedUser = this._authService.getUserFromLocalStorage();
    if (!this.attending.scheduling) {
      this.attending.scheduling = new Scheduling();
    }
    if (!this.attending.scheduling.technician) {
      this.attending.scheduling.technician = new Technician();
    }
    if (this.canEdit() && this.attending.scheduling.scheduleDate && !this.time) {
      const date = new Date(this.attending.scheduling.scheduleDate);
      this.date = moment(date).format('DD/MM/YYYY');
      this.time = moment(date).format('HH:mm');
    }
    if (this.attending.attendingInfo.autoEletric) {
      this.autoEletricId = this.attending.attendingInfo.autoEletric.id;
      this.autoEletricChoosedOnScheduling = false;
    }
  }

  private setUpObservers() {
    this._autoEletricService.find$
      .filter(result => result instanceof Array)
      .subscribe(autoEletrics => this.userAutoEletrics = autoEletrics);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/scheduling/scheduling.component.ts